// Copyright (C) 2021 TANNER AG

import React from "react";

const Logo = ({ className }) => {
    return (
        <svg className={className} width="100" height="56" viewBox="0 0 100 56" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <linearGradient x1="0%" y1="50%" y2="50%" id="a">
                    <stop stop-color="#FFF" offset="0%" />
                    <stop stop-color="#F9F9F9" offset="30%" />
                    <stop stop-color="#D1D3D4" offset="40%" />
                    <stop stop-color="#7B7D7F" offset="50%" />
                    <stop stop-color="#525254" offset="60%" />
                    <stop stop-color="#231F20" offset="100%" />
                </linearGradient>
                <linearGradient x1="101.834%" y1="85.607%" x2="5.832%" y2="38.962%" id="b">
                    <stop stop-color="#FFF" offset="0%" />
                    <stop stop-color="#F8F8F8" offset="60%" />
                    <stop stop-color="#E4E5E6" offset="70%" />
                    <stop stop-color="#939598" offset="80%" />
                    <stop stop-color="#58595B" offset="90%" />
                    <stop stop-color="#231F20" offset="100%" />
                </linearGradient>
                <linearGradient x1="15.201%" y1="122.156%" x2="84.85%" y2="-22.104%" id="c">
                    <stop stop-color="#808285" offset="0%" />
                    <stop stop-color="#E6E7E8" offset="100%" />
                </linearGradient>
                <linearGradient x1="1.982%" y1="46.111%" x2="101.608%" y2="62.104%" id="d">
                    <stop stop-color="#808285" offset="0%" />
                    <stop stop-color="#D4D6D7" offset="20%" />
                    <stop stop-color="#E3E4E5" offset="30%" />
                    <stop stop-color="#E3E4E5" offset="70%" />
                    <stop stop-color="#D1D3D4" offset="80%" />
                    <stop stop-color="#808285" offset="100%" />
                </linearGradient>
                <linearGradient x1="98.945%" y1="102.851%" x2="1.033%" y2="-2.928%" id="e">
                    <stop stop-color="#808285" offset="0%" />
                    <stop stop-color="#E6E7E8" offset="100%" />
                </linearGradient>
                <linearGradient x1="46.646%" y1="123.095%" x2="64.492%" y2="-.225%" id="f">
                    <stop stop-color="#ABADB0" offset="0%" />
                    <stop stop-color="#E6E7E8" offset="100%" />
                </linearGradient>
            </defs>
            <g fill="none" fill-rule="evenodd">
                <path fill="#303C49" d="M0 0h100v56H0z" />
                <path fill="#E40045" fill-rule="nonzero" d="M0 56h4V0H0z" />
                <g>
                    <path
                        d="M24.775 35.894H29.5l3.15 3.163 3.149-3.163h4.725v9.684h-5.099V42.02L32.65 44.81l-2.776-2.789v3.558h-5.1v-9.684zm34.64 0h4.975l5.602 4.174v-4.174h5.098v9.684h-5.012l-5.565-4.137v4.137h-5.098v-9.684z"
                        fill="#ABADB0"
                    />
                    <path
                        d="M19 42.155C19 24.97 32.868 11.04 49.976 11.04c17.109 0 30.977 13.93 30.977 31.114 0 1.157-.063 2.3-.186 3.423h-3.479c.138-1.122.21-2.264.21-3.423 0-15.267-12.322-27.643-27.522-27.643s-27.52 12.376-27.52 27.643c0 1.159.07 2.301.209 3.423h-3.48A31.632 31.632 0 0 1 19 42.155z"
                        fill="#ABADB0"
                    />
                    <path
                        d="M47.34 35.894h5.292l6.276 9.684h-5.301l-.68-1.055h-5.881l-.68 1.055h-5.301l6.275-9.684zm2.646 4.04l-1.181 1.834h2.363l-1.182-1.835z"
                        fill="#ABADB0"
                    />
                    <path
                        d="M59.054 33.896c.087-.902.13-1.815.13-2.739 0-15.647-12.628-28.33-28.205-28.33-15.578 0-28.206 12.683-28.206 28.33 0 .924.044 1.837.13 2.739l.486.439a28.305 28.305 0 0 1-.178-3.178c0-15.404 12.432-27.89 27.768-27.89s27.768 12.486 27.768 27.89c0 1.074-.06 2.135-.178 3.178l.485-.44z"
                        fill="url(#a)"
                        transform="translate(19 11)"
                    />
                    <path
                        d="M29.399 36.14H25.02v9.192h4.608v-3.906l3.022 3.035 3.022-3.035v3.906h4.608V36.14h-4.379l-3.25 3.266-3.252-3.266zm34.91 0H59.66v9.192h4.608v-4.38l5.89 4.38h4.687V36.14h-4.608v4.418l-5.928-4.418z"
                        fill="#FFF"
                        fill-rule="nonzero"
                    />
                    <path
                        d="M51.62 42.014h-3.266l1.632-2.534 1.633 2.534zm.88-5.874h-5.027l-5.956 9.192h4.716l.68-1.056h6.147l.68 1.056h4.716l-5.957-9.192z"
                        fill="#FFF"
                    />
                    <path
                        d="M49.986 38.672v.808c-.595 1.273-1.14 2.118-1.632 2.534l-.804.44 2.436-3.782z"
                        fill="#ABADB0"
                    />
                    <path
                        d="M19.804 44.893h2.1l.485.44h-2.983l.398-.44zm58.246 0h2.1l.397.44h-2.983l.486-.44zM25.02 36.14l.437.44v8.313h3.734l.437.44H25.02V36.14zm4.171 4.225l3.46 3.474 3.458-3.474v4.528h3.734l.437.44h-4.608v-3.907L32.65 44.46l-3.022-3.035-.437-1.06zm3.46-.96l3.25-3.265.182.44-3.433 3.447v-.621zm17.335-.733l2.437 3.781-.804-.44-1.633-2.533v-.808zm9.674-2.532l.438.44v8.313h3.732l.438.44H59.66V36.14zm4.17 3.94l6.473 4.813h4.105l.437.44H70.16l-5.891-4.38-.438-.872zm6.407-3.94l.437.44v4.85l-.437-.872V36.14z"
                        fill="#231F20"
                    />
                    <path
                        d="M61.551 34.335c.107-1.045.161-2.105.161-3.178 0-17.049-13.76-30.87-30.733-30.87C14.005.288.245 14.109.245 31.158c0 1.073.055 2.133.161 3.178l.398-.44a31 31 0 0 1-.121-2.738C.683 14.351 14.246.727 30.979.727c16.732 0 30.296 13.624 30.296 30.43a31 31 0 0 1-.12 2.739l.396.439z"
                        fill="url(#b)"
                        transform="translate(19 11)"
                    />
                    <path
                        fill="#231F20"
                        fill-rule="nonzero"
                        d="M46.674 43.837h6.624l.68 1.056h3.671l.807.44H53.74l-.68-1.057h-6.148l-.679 1.056h-4.716l5.956-9.192.237.44-5.386 8.313h3.671l.68-1.056z"
                    />
                    <path
                        fill="url(#c)"
                        d="M10.219 25.582H6.458v8.314h3.734v-4.528l3.46 3.474 3.459-3.475v4.529h3.733v-8.314h-3.76L13.65 29.03l-3.432-3.448z"
                        transform="translate(19 11)"
                    />
                    <path
                        d="M30.979.727C14.246.727.683 14.351.683 31.157a31 31 0 0 0 .12 2.739h2.1a28.785 28.785 0 0 1-.13-2.739c0-15.647 12.628-28.33 28.206-28.33 15.577 0 28.205 12.683 28.205 28.33 0 .924-.043 1.837-.13 2.739h2.1a31 31 0 0 0 .121-2.739c0-16.806-13.564-30.43-30.296-30.43z"
                        fill="url(#d)"
                        transform="translate(19 11)"
                    />
                    <path
                        fill="url(#e)"
                        d="M45.168 25.582h-4.067v8.314h3.733v-4.813l6.473 4.813h4.105v-8.314h-3.734v4.851l-6.51-4.851z"
                        transform="translate(19 11)"
                    />
                    <path
                        d="M33.426 31.456h-4.874l2.437-3.782 2.437 3.782zm-.161-5.874h-4.553l-5.386 8.314h3.671l.68-1.057H34.3l.68 1.057h3.671l-5.387-8.314z"
                        fill="url(#f)"
                        fill-rule="nonzero"
                        transform="translate(19 11)"
                    />
                </g>
            </g>
        </svg>
    );
};

export default Logo;



// WEBPACK FOOTER //
// ./src/layouts/Logo.js